import { Grid, Checkbox, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import EmployeeContainer from 'containers/account/EmployeeContainer';
import UnitPriceContainer from 'containers/account/UnitPriceContainer';
import SalesPointContainer from 'containers/account/SalesPointContainer';
import WarrantyContainer from 'containers/account/WarrantyContainer';
import PageTitle from 'components/base/title/PageTitle';
import { useShallowAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { isClinicUserSelector } from 'store/modules/user';
interface AccountInfoProps {
  // page: object | any;
  // period: object | any;
  // checkedProjectProcess: object | any;
  // keyword: object | any;
}
//Resolve #11
function AcctounContainer({}: AccountInfoProps) {
  const {
    user,

    isClinicUser,
  } = useShallowAppSelector(state => ({
    user: state.user.user,

    isClinicUser: isClinicUserSelector(state),
  }));
  const { t } = useTranslation();
  return (
    <StyledAcctounInfo data-component-name="AcctounInfo">
      <PageTitle title={t('NAV_MENU_ACCOUNT')} />
      {!isClinicUser && (
        <Grid container className="acctounInfo__sales_unit_wrapper">
          <Grid item className="acctounInfo__content_wrapper sales">
            <SalesPointContainer />
          </Grid>
          <Grid item className="acctounInfo__content_wrapper unit">
            <UnitPriceContainer />
          </Grid>
        </Grid>
      )}

      <EmployeeContainer />
      {/* NOTE: warranty 추후 추가 */}
      <WarrantyContainer />
    </StyledAcctounInfo>
  );
}

const StyledAcctounInfo = styled.section<{}>`
  /* padding-bottom: 120px; */
  .acctounInfo__sales_unit_wrapper {
    padding-bottom: 40px;
    flex-wrap: initial;
  }
  .acctounInfo__content_wrapper {
    flex-wrap: wrap;
    &.sales {
      /* width: 466px; */
      width: 470px;
      margin-bottom: 20px;
    }
    &.unit {
      /* width: 1162px; */
      width: 1200px;
      margin-left: -30px;
      margin-bottom: 20px;
    }
  }
`;

export default React.memo(AcctounContainer);
